import React from 'react'
import './publication.css'

function Volume24no34() {
  return (
    <div className="p-2">
      <section className='content-header d-flex flex-column justify-content-start'>
        <h3 className="p-2" >Vol. 24, Nos. 3&4, Sep/Dec 2023</h3>
        <h5 className="p-2">CONTENTS</h5>
            <div className="p-2 contents">
             <a href= '/volume-24-no3&4/AreO.B-CriticalityofNonverbalCommunication.pdf'><p> The Criticality of Nonverbal Communication in Language Development: 
Evidences from Autism Spectrum Disorder (ASD) - 
 <strong> Olushola Bamidele Are</strong> - 1 </p> </a> 
              </div>
              <div className="p-2">
            <a href= '/volume-24-no3&4/Afejuku,T.&E.Mukoro-Religion-philosophical Excursion.pdf'><p>A Religio-philosophical Excursion into A.N. Akwanya's Poetry - 
 <strong> Tony E. Afejuku & Edafe Mukoro</strong> - 11 </p></a> 
              </div>
              <div className="p-2">
              <a href= '/volume-24-no3&4/AiyetoroBosede-ExileandtheMakingofNewHomes.pdf'><p> Exile and the Making of New Homes in Segun Afolabi's A Life Elsewhere and 
Chimamanda Adichie's The Thing around Your Neck - 
 <strong> Mary Bosede Aiyetoro</strong> - 21 </p></a>
              </div>
              <div className="p-2">
              <a href= '/volume-24-no3&4/Aongo,S.F.&S.M.Ohitoto-PragmaticAnalysisofNigeriasPresidentsSpeech.pdf'> <p> A Pragmatic Analysis of Nigeria's President Bola Ahmed Tinubu's Acceptance Speech 
as his Party's Presidential Candidate, 2023 - 
 <strong> Solomon Fashie Aongo & Salamatu Muhammed Ohitoto</strong> - 37 </p></a>
              </div>
              <div className="p-2">
              <a href= '/volume-24-no3&4/Essien,I.N.G.&O.R.Osewa-TheSyllableinDefaka.pdf'><p> The Syllable in Defaka: A Re-analysis - 
 <strong> Inoma N. G. Essien & O. R. Osewa</strong> - 48 </p></a>
              </div>
              <div className="p-2">
             <a href='/volume-24-no3&4/Olarewaju,E.O.-Vocational-TechnicalEducationinNigeria.pdf'> <p> Vocational/Technical Education in Nigeria: Challenge of Communicative Competence 
in the Written English of Technical College Students in Osun State, Nigeria - 
 <strong> Eunice Omolara Olarewaju</strong> - 60 </p> </a>
              </div>              
            <hr/>
    
        </section>
    </div>
  )
}

export default Volume24no34;







